import GetPrevNextContractIds from
  '@/graphql/contracts/getPrevNextContractIds.query.gql';
import { GetPrevNextContractIdsQuery, GetPrevNextContractIdsQueryVariables } 
  from '@/graphql/contracts/_generated_/getPrevNextContractIds.query';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

export default function useGetPrevNextContractIds() {
  const getPrevNextContractIds = async (dto: GetPrevNextContractIdsQueryVariables) => {
    const response = await apolloClientContracts.query<
    GetPrevNextContractIdsQuery,
    GetPrevNextContractIdsQueryVariables
    >({
      query: GetPrevNextContractIds,
      variables: {
        ...dto,
      },
    });
    return response.data;
  };
  return {
    getPrevNextContractIds,
  } as const;
}